import React, { useState, useContext, useEffect } from "react"
import history from "../../utils/history"
import api from "../../api/api"
import Context from "../../utils/Context"
import Logo from "../../assets/images/logo.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faLock, faCog } from '@fortawesome/free-solid-svg-icons'
import ShowMessage from "../../components/ShowMessage"
import SettingsRemote from "../../components/SettingsRemote"

const LoginForm = () => {
  const [isLoading, setIsloading] = useState(false)
  const context = useContext(Context)

  useEffect(() => {
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey)
  }, []);

  const handleKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      onSubmit()
    }
  };

  const onSubmit = async () => {
    const username = document.getElementById("username").value;
    const password = document.getElementById("password").value;

    if (!context.settings.fmsConnection) {
      context.actions.setMessage({ message: "Opening remote in offline mode...", type: "error" })
      setIsloading(true)
      setTimeout(() => {
        history.push("/")
        setIsloading(false)
      }, [2000])
      return
    }

    console.log(username, password)

    if (username && password) {
      setIsloading(true)

      try {
        const res = await api.connect(username, password)

        if (!res || res.data.status === 401) {
          context.actions.setMessage({ message: "Invalid credentials.", type: "error" })
          setIsloading(false)
        }

        if (res.data.token) {
          context.actions.setApiToken(res.data.token)
          localStorage.setItem('apiToken', res.data.token)
          context.actions.setUser(res.data)
          history.push("/")
        }
      } catch (error) {

        context.actions.setMessage({ message: "Invalid credentials.", type: "error" })
        setIsloading(false)
      }
    } else {
      context.actions.setMessage({ message: "Please fill all fields.", type: "error" })
    }
  }

  //console.log("login render")

  return (
    <div className="login-form">
      <figure>
        <img
          width="216"
          height="33"
          alt="logo-follow"
          src={Logo}
          className="mb-6"
        ></img>
      </figure>

        <div className="field">
          <p className="title is-size-2-desktop is-size-2-tablet is-size-3-mobile mb-6 is-family-monospace">
            Sign In
          </p>
          <p className="control has-icons-left mb-5">
            <input
              className="input"
              type="text"
              placeholder="Username"
              id='username'
            />
            <span className="icon is-small is-left">
              <FontAwesomeIcon icon={faUser} className="fas" />
            </span>
          </p>
        </div>
        <div className="field">
          <p className="control has-icons-left mb-5">
            <input
              className="input"
              type="password"
              placeholder="Password"
              id='password'
            />
            <span className="icon is-small is-left">
              <FontAwesomeIcon icon={faLock} className="fas" />
            </span>
          </p>
        </div>
        <div className="field">
          <div className="control is-flex" style={{ gap: '0.5rem' }}>
            <button
              className={
                isLoading
                  ? "button is-success is-fullwidth has-background-primary has-text-white is-loading"
                  : "button is-success is-fullwidth has-background-primary has-text-white"
              }
              onClick={() => onSubmit()}
            >
              Enter
            </button>
            {isLoading && (
              <button
                className="button is-danger"
                onClick={() => setIsloading(false)}
                title="Cancelar"
              >
                X
              </button>
            )}
          </div>
        </div>

      <ShowMessage />
      <button
        className="button is-info is-light is-active mr-2 mb-2 is-pulled-left"
        onClick={() => context.actions.setModalState({ ...context.modalState, settingsRemote: !context.modalState.settingsRemote })}
      >
        <FontAwesomeIcon icon={faCog} className="fas" />
      </button>
      {context.modalState.settingsRemote && <SettingsRemote />}
    </div>
  );
};

export default function Login() {
  return (
    <div
      className="columns is-tablet is-gapless has-background-white"
      style={{ height: "100vh" }}
    >
      <div className="column  has-background-primary"></div>
      <div className="column is-flex" style={{ justifyContent: "center" }}>
        <LoginForm />
      </div>
    </div>
  );
}
